export default __webpack_public_path__ + "images/32_thumbnail.jpg";